export default [{
  path: '/education',
  name: 'education',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/education/index')
}]
